// extracted by mini-css-extract-plugin
export default {"wrapper":"compariosn-card_wrapper__8MKhr","boxImage":"compariosn-card_boxImage__1Sbu7"};